import { type ButtonHTMLAttributes } from "react";
import { Icon, type IconName } from "./icons";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Accessible label — required; sets aria-label. */
  label: string;
  name: IconName;
  size?: number;
}

export function IconButton({
  label,
  name,
  size = 16,
  className = "",
  ...rest
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className={`icon-btn-kit ${className}`.trim()}
      {...rest}
    >
      <Icon name={name} size={size} />
    </button>
  );
}
